import Layout from "@/layout";

const customerRouter = {
  path: "/customer",
  component: Layout,
  redirect: "/customer/customerManage",
  name: "customer",
  meta: {
    title: "客户关系管理",
    icon: "clipboard",
  },
  children: [
     {
      path: "reportStatistics2",
      component: () => import("@/views/customer/reportStatistics2/index"),
      name: "reportStatistics2",
      meta: { title: "个人报表统计", icon: "" },
    },
    {
      path: "reportStatistics",
      component: () => import("@/views/customer/reportStatistics/index"),
      name: "reportStatistics",
      meta: { title: "报表统计", icon: "" },
    },
    {
      path: "customerManage",
      component: () => import("@/views/customer/customerManage/index"),
      name: "customerManage",
      meta: { title: "客户管理", icon: "" },
    },
    {
      path: "clueManage",
      component: () => import("@/views/customer/clueManage/index"),
      name: "clueManage",
      meta: { title: "线索管理", icon: "" },
    },
    {
      path: "bookingRecord",
      component: () => import("@/views/customer/bookingRecord/index"),
      name: "bookingRecord",
      meta: { title: "预约记录", icon: "" },
    },
    {
      path: "bookingList",
      component: () => import("@/views/customer/bookingList/index"),
      name: "bookingList",
      meta: { title: "预约列表", icon: "" },
    },
  ],
};

export default customerRouter;
